module.exports = __webpack_public_path__ + "img/step2.b104aa6.png";